// extracted by mini-css-extract-plugin
export default {"colors":"accent,neutral,negative,warning,positive","toolbarButtons":"styles_toolbarButtons__pVAsh"};